import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { useDispatch } from 'react-redux';
import {
    editComplaint,
    fetchComplaints,
} from '../../app/reducers/Complaints/complaintSlice';
import moment from 'moment';

const CancelModal = ({
    openCancelModal,
    setOpenCancelModal,
    complaintData,
    page,
    status
}) => {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            ...complaintData,
            cancellationNotes: '',
            cancelDate: '',
        },
        validationSchema: object({
            cancellationNotes: string().required(),
            cancelDate: string().required(),
        }),
        onSubmit: async (values) => {
            console.log('values', values);
            await dispatch(
                editComplaint({
                    ...values,
                    status: 'canceled',
                })
            );
            await dispatch(
                fetchComplaints({
                    populate: true,
                    page,
                    status,
                })
            );
            setOpenCancelModal(false);
            formik.resetForm();
        },
    });

    useEffect(() => {
        if (openCancelModal) {
            formik.setFieldValue('cancelDate', moment().valueOf());
        }
    }, [openCancelModal]);

    return (
        <ModalBasic
            modalOpen={openCancelModal}
            setModalOpen={setOpenCancelModal}
            title={'Cancel Complaint'}
            max_width="max-w-lg"
        >
            <div className="p-4">
                <form
                    className="flex flex-col gap-4"
                    onSubmit={formik.handleSubmit}
                >
                    <div className="grid grid-cols-2 gap-3 pb-4 border-b border-slate-200">
                        <FormikInputGroup formik={formik} label="Complaint No." name="complaintNumber" readOnly value={`CMP-${formik.values.complaintNumber || ''}`} />
                        <FormikInputGroup formik={formik} label="Customer" name="customer.name" readOnly />
                        <FormikInputGroup formik={formik} label="Company" name="customer.companyData.name" readOnly />
                        <FormikInputGroup formik={formik} label="Machine" name="product.name" readOnly />
                        <FormikInputGroup formik={formik} label="Technician" name="assignedTo" readOnly />
                        <div className="col-span-2">
                            <FormikInputGroup formik={formik} label="Description" name="description" readOnly fullWidth />
                        </div>
                    </div>

                    <FormikInputDateGroup
                        formik={formik}
                        label="Cancel Date"
                        name="cancelDate"
                        required
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                    />
                    <FormikInputGroup
                        formik={formik}
                        name="cancellationNotes"
                        label="Cancellation Note"
                    />
                    <div className="">
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                </form>
            </div>
        </ModalBasic>
    );
};

export default CancelModal;
